import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'careerMaterials';

export const careerService = {
  // Получить все материалы
  async getAllMaterials() {
    try {
      const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting career materials:', error);
      throw error;
    }
  },

  // Получить материал по ID
  async getMaterialById(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error('Material not found');
      }
    } catch (error) {
      console.error('Error getting material:', error);
      throw error;
    }
  },

  // Создать новый материал
  async createMaterial(materialData) {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...materialData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        views: 0,
        author: 'Администратор'
      });
      return docRef.id;
    } catch (error) {
      console.error('Error creating material:', error);
      throw error;
    }
  },

  // Обновить материал
  async updateMaterial(id, materialData) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...materialData,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating material:', error);
      throw error;
    }
  },

  // Удалить материал
  async deleteMaterial(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting material:', error);
      throw error;
    }
  }
};
